import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/Product/ECommerce/eCommerce.container"
    ).then((module) => ({
        default: module.ECommerceContainer
    }))
);
